// extracted by mini-css-extract-plugin
export default {"form":"ContactForm_form__KdAdT","successMessage":"ContactForm_successMessage__YwbCZ","errorMessage":"ContactForm_errorMessage__5HA8L"};